(() => {
  const modal = document.getElementById("SizeSelectModal");
  if (!modal) return;

  const form = document.getElementById("SizeSelectForm");
  const select = document.getElementById("SizeSelectOption");
  const titleEl = document.getElementById("SizeSelectTitle");
  const errEl = document.getElementById("SizeSelectError");

  let currentProduct = null;

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error("Produit introuvable");
    return res.json();
  }

  function getSizeOptionIndex(product) {
    return (product.options || []).findIndex((o) => {
      const v = (o || "").toLowerCase();
      return v === "taille" || v === "size";
    });
  }

  function openModal(product) {
    currentProduct = product;
    titleEl.textContent = product.title || "";

    errEl.style.display = "none";
    errEl.textContent = "";

    select.innerHTML = `<option value="" selected>Choisir une taille</option>`;

    const sizeIndex = getSizeOptionIndex(product);

    // Si pas de tailles (1 variante)
    if (sizeIndex === -1) {
      select.disabled = true;
      select.style.display = "none";
    } else {
      select.disabled = false;
      select.style.display = "";

      const sizes = new Set();
      (product.variants || []).forEach((v) => {
        if (v.available) sizes.add(v.options[sizeIndex]);
      });

      [...sizes].forEach((s) => {
        const opt = document.createElement("option");
        opt.value = s;
        opt.textContent = s;
        select.appendChild(opt);
      });
    }

    modal.showModal();
  }

  function findVariantId(product, chosenSize) {
    if (!product.variants || product.variants.length === 0) return null;

    const sizeIndex = getSizeOptionIndex(product);
    if (sizeIndex === -1) return product.variants[0].id;

    const match = product.variants.find(
      (v) => v.available && v.options && v.options[sizeIndex] === chosenSize
    );
    return match ? match.id : null;
  }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity }),
    });
    if (!res.ok) throw new Error("Erreur ajout panier");
    return res.json();
  }

  // Refresh drawer - version simple et robuste
  // Si tu n'as pas de section "cart-drawer", crée sections/cart-drawer.liquid qui fait {% render 'cart-drawer' %}
  async function refreshCartDrawer() {
    const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
    if (!res.ok) return;

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    const newDrawer = doc.querySelector("cart-drawer");
    const currentDrawer = document.querySelector("cart-drawer");

    if (newDrawer && currentDrawer) {
      currentDrawer.replaceWith(newDrawer);
    }

    // Ré-ouvrir
    const drawerEl = document.querySelector("cart-drawer");
    if (drawerEl && typeof drawerEl.open === "function") drawerEl.open();
  }

  // Open modal
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".js-open-size-modal");
    if (!btn) return;

    e.preventDefault();
    const handle = btn.getAttribute("data-product-handle");
    if (!handle) return;

    try {
      const product = await fetchProduct(handle);
      openModal(product);
    } catch (err) {
      console.error(err);
      alert("Impossible de charger le produit.");
    }
  });

  // Close
  form.querySelector(".size-modal__close")?.addEventListener("click", () => modal.close());

  // Submit
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (!currentProduct) return;

    const needsSize = select.style.display !== "none";
    const chosenSize = needsSize ? select.value : null;

    if (needsSize && !chosenSize) {
      errEl.textContent = "Choisis une taille pour ajouter le produit.";
      errEl.style.display = "";
      return;
    }

    const variantId = findVariantId(currentProduct, chosenSize);
    if (!variantId) {
      errEl.textContent = "Cette taille n’est pas disponible.";
      errEl.style.display = "";
      return;
    }

    try {
      await addToCart(variantId, 1);
      modal.close();
      await refreshCartDrawer();
    } catch (err) {
      console.error(err);
      errEl.textContent = "Erreur lors de l’ajout au panier.";
      errEl.style.display = "";
    }
  });
})();
